import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const vehiclesFilterSchema = z.object({
	search: optionalFilterString,
});

export type VehiclesFilter = z.infer<typeof vehiclesFilterSchema>;
